/* ============================================================
   URBAN CLAW — the claw machine game. Builds itself inside every
   [data-claw] element, reading its prizes from the JSON block inside
   it (written by snippets/tear-seam.liquid). Styles: urbanleb-claw.css
   The wax seal logo is assets/urbanleb-seal.webp (found next to this
   script), used on the headline and on the printed prize slip.
   Nothing runs until someone plays: the animation loop only runs
   during a game, and the lights only animate while on screen.
   ============================================================ */
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SEAL = (function () { var s = document.currentScript || document.querySelector('script[src*="urbanleb-claw.js"]'); return s && s.src ? s.src.replace(/urbanleb-claw\.js.*$/, 'urbanleb-seal.webp') : ''; })();

  /* ---------- tiny arcade synth (only after the player taps) ---------- */
  var AC = null, muted = false, hum = null;
  try { muted = localStorage.getItem('ucl_mute') === '1'; } catch (e) {}
  function ctx() {
    if (muted) return null;
    if (!AC) { try { AC = new (window.AudioContext || window.webkitAudioContext)(); } catch (e) { return null; } }
    if (AC.state === 'suspended') AC.resume();
    return AC;
  }
  function tone(f, dur, type, vol, to, delay) {
    var c = ctx(); if (!c) return;
    var t = c.currentTime + (delay || 0), o = c.createOscillator(), g = c.createGain();
    o.type = type || 'square'; o.frequency.setValueAtTime(f, t);
    if (to) o.frequency.exponentialRampToValueAtTime(to, t + dur);
    g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(vol || 0.06, t + 0.012);
    g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    o.connect(g); g.connect(c.destination); o.start(t); o.stop(t + dur + 0.03);
  }
  var SFX = {
    coin: function () { tone(988, .07, 'square', .05); tone(1319, .28, 'square', .05, null, .07); },
    go: function () { [523, 659, 784, 1047].forEach(function (f, i) { tone(f, .08, 'square', .04, null, i * .07); }); },
    tick: function () { tone(1400, .035, 'square', .025); },
    drop: function () { tone(520, .95, 'triangle', .035, 190); },
    clunk: function () { tone(150, .1, 'square', .07, 60); tone(80, .16, 'triangle', .09); },
    up: function () { tone(190, 1.05, 'triangle', .035, 460); },
    slip: function () { tone(392, .17, 'triangle', .06, 370); tone(330, .17, 'triangle', .06, 300, .17); tone(262, .45, 'triangle', .06, 190, .34); },
    thud: function () { tone(110, .18, 'sine', .1, 50); },
    win: function () { [523, 659, 784, 1047, 784, 1047, 1319].forEach(function (f, i) { tone(f, .13, 'square', .05, null, i * .09); }); tone(1568, .6, 'triangle', .05, null, .66); },
    print: function () { for (var i = 0; i < 4; i++) tone(260 + i * 15, .12, 'sawtooth', .012, null, i * .3); }
  };
  /* the claw's motor: a soft, rounded whir (two gentle tones through a low filter) that glides in and out */
  function humOn() {
    var c = ctx(); if (!c || hum) return;
    var a = c.createOscillator(), b = c.createOscillator(), f = c.createBiquadFilter(), g = c.createGain();
    a.type = 'triangle'; a.frequency.value = 92; b.type = 'sine'; b.frequency.value = 185;
    f.type = 'lowpass'; f.frequency.value = 340; f.Q.value = .4; g.gain.value = 0.0001;
    a.connect(f); b.connect(f); f.connect(g); g.connect(c.destination); a.start(); b.start(); hum = { o: [a, b], f: f, g: g };
  }
  function humLevel(v) {
    if (!hum || !AC) return; var t = AC.currentTime;
    hum.g.gain.setTargetAtTime(v ? 0.03 : 0.0001, t, v ? .09 : .14);
    hum.o[0].frequency.setTargetAtTime(v ? 104 : 92, t, .25); hum.o[1].frequency.setTargetAtTime(v ? 209 : 185, t, .25);
    hum.f.frequency.setTargetAtTime(v ? 420 : 300, t, .2);
  }
  function humOff() {
    if (!hum) return; var h = hum; hum = null;
    try { h.g.gain.setTargetAtTime(0.0001, AC.currentTime, .08); h.o.forEach(function (o) { o.stop(AC.currentTime + .4); }); } catch (e) {}
  }
  function buzz(p) { try { navigator.vibrate && navigator.vibrate(p || 25); } catch (e) {} }

  var CLAW_SVG = '<svg class="ucl-claw open" viewBox="0 0 62 66" aria-hidden="true"><defs>'
    + '<linearGradient id="uclChr" x1="0" x2="1"><stop offset="0" stop-color="#5F6A75"/><stop offset=".45" stop-color="#F6F9FB"/><stop offset=".7" stop-color="#9AA6B1"/><stop offset="1" stop-color="#D9E0E6"/></linearGradient>'
    + '<linearGradient id="uclPrg" x1="0" x2="1"><stop offset="0" stop-color="#7D8994"/><stop offset=".5" stop-color="#EEF2F5"/><stop offset="1" stop-color="#6B7782"/></linearGradient></defs>'
    + '<g class="p pl"><path d="M21 19 C11 27 6 39 9 52 C10 57 14 59 17 56 C14 47 15 37 23 27 Z" fill="url(#uclPrg)" stroke="#2B3138" stroke-width=".8"/></g>'
    + '<g class="p pr"><path d="M41 19 C51 27 56 39 53 52 C52 57 48 59 45 56 C48 47 47 37 39 27 Z" fill="url(#uclPrg)" stroke="#2B3138" stroke-width=".8"/></g>'
    + '<g class="p pc"><path d="M28 19 L34 19 L33.4 47 C33 53 29 53 28.6 47 Z" fill="url(#uclPrg)" stroke="#2B3138" stroke-width=".8"/></g>'
    + '<rect x="19" y="0" width="24" height="15" rx="5" fill="url(#uclChr)" stroke="#2B3138" stroke-width=".8"/>'
    + '<rect x="14" y="12" width="34" height="9" rx="3.5" fill="url(#uclChr)" stroke="#2B3138" stroke-width=".8"/>'
    + '<circle cx="21" cy="16.5" r="1.4" fill="#2B3138"/><circle cx="41" cy="16.5" r="1.4" fill="#2B3138"/><circle class="led" cx="31" cy="7.5" r="2.6"/></svg>';
  var SPK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9v6h4l5 4V5L8 9z" fill="currentColor"/><path class="w" d="M16 9a4 4 0 0 1 0 6M18.5 6.5a7.5 7.5 0 0 1 0 11"/><path class="x" d="M16 9l5 6M21 9l-5 6"/></svg>';

  function shell(d, seal) {
    return '<div class="ucl-fit">'
      + '<div class="ucl-head"><div class="ucl-meta"><span>' + esc(d.eyebrow || 'Nº 01 — Free play') + '</span><span><i></i><b data-n></b> pieces inside</span></div>'
      +  '<div class="ucl-title"><h2 class="ucl-h">Pull a <br><em>piece</em><b>.</b></h2>' + (seal ? '<img class="ucl-seal" src="' + esc(seal) + '" alt="urban.leb">' : '') + '</div>'
      +  (d.coins ? '<div class="ucl-wallet" data-w></div>' : '<p class="ucl-sub">Three pulls. Whatever you grab is <b>yours at up to ' + esc(d.maxOff || (d.codes && d.codes.jackpotOff) || 15) + '% off.</b></p>') + '</div>'
      + '<div class="ucl-mach"><div class="ucl-cab">'
      /* phones: a lit sign on top of the cabinet, like an arcade marquee, carries the title and the coins */
      +  '<div class="ucl-marq">' + (seal ? '<img class="ucl-mq-seal" src="' + esc(seal) + '" alt="urban.leb">' : '') + '<div class="ucl-mq-t">Pull a <em>piece</em><b>.</b></div>'
      +   '<div class="ucl-mq-w" data-mw></div><div class="ucl-mq-s" data-ms></div><span class="ucl-mq-bar"><i data-mb></i></span></div>'
      +  '<div class="ucl-crown"><div class="ucl-tick" aria-hidden="true"><div class="ucl-tick-in"><span data-tk></span><span data-tk></span></div></div>'
      +   '<button class="ucl-mute" type="button" aria-label="Sound" aria-pressed="false">' + SPK + '</button></div>'
      +  '<div class="ucl-glass">'
      +   '<span class="ucl-wm" aria-hidden="true">URBAN.LEB</span><span class="ucl-floor"></span><span class="ucl-step"></span>'
      +   '<span class="ucl-tube"></span><span class="ucl-rail"></span><span class="ucl-car"></span>'
      +   '<div class="ucl-rig"><span class="ucl-beam"></span><span class="ucl-cable"></span>' + CLAW_SVG + '</div>'
      +   '<div class="ucl-pile"></div><span class="ucl-mark"></span><div class="ucl-chute"><span>DROP ZONE</span></div>'
      +   '<div class="ucl-hud"><div class="ucl-chip" data-tb><small>TIME</small><b data-t>00:20</b></div>'
      +    '<div class="ucl-chip" style="text-align:right"><small>PULLS</small><div class="ucl-tries"><i></i><i></i><i></i></div></div></div>'
      +   '<div class="ucl-msg blink on" data-m></div><div class="ucl-glare"></div><div class="ucl-flash"></div><canvas class="ucl-fx"></canvas>'
      +  '</div>'
      +  '<div class="ucl-deck"><span class="ucl-tslot"></span>'
      +   '<div class="ucl-ctl"><div class="ucl-joy" role="slider" tabindex="0" aria-label="Move the claw" aria-valuemin="-1" aria-valuemax="1" aria-valuenow="0"><div class="ucl-stick"><span class="ucl-dust"></span><span class="ucl-shaft"></span><span class="ucl-ball"></span></div></div><span class="ucl-lbl">MOVE ✥</span></div>'
      +   '<div class="ucl-mid"><button class="ucl-coin" type="button" aria-label="Insert coin">UL</button><span class="ucl-slot"></span><span class="ucl-slot-l blink" data-sl>Insert coin</span></div>'
      +   '<div class="ucl-ctl"><button class="ucl-drop" type="button" aria-label="Drop the claw"><span class="ring"></span><span class="dome">DROP</span></button><span class="ucl-lbl">GRAB</span></div></div>'
      +  '<div class="ucl-plate"><span>URBAN.LEB AMUSEMENTS</span><span class="ucl-vent"></span><span>BEIRUT · LB</span></div>'
      +  '<div class="ucl-tkw"><div class="ucl-tk"></div></div>'
      + '</div>'
      + '<div class="ucl-cap"><span>' + esc(d.caption || 'Win a piece · get its code') + '</span><a href="' + esc(d.shopAll || '/collections/all') + '">Shop all →</a></div></div>'
      + '<div class="ucl-how" data-how></div><div class="ucl-board" data-board></div>'
      + '</div>';
  }
  /* on computers the sheet gets a side column or two: how it works, and the prize board */
  function howHTML(d) {
    var per = Math.round(((d.coins && d.coins.per) || 20000) / 100), until = d.coins && d.coins.until;
    var S = [['Your first play is free', 'Have a pull on us. <strong>Sign in</strong> and a fresh coin lands on the <strong>1st of every month</strong>.'],
             ['Spend more, earn more', 'Every <strong>$⁠' + per + '</strong> you spend in a month adds another coin. Your orders add up.'],
             ['Three pulls a coin', 'Grab a piece and your code prints on the spot. ' + (until ? '<strong>Use it by ' + esc(until) + '.</strong>' : 'Use it by the <strong>14th of next month</strong>.')]];
    return '<div class="ucl-eye"><span>How it works</span><span>01—03</span></div>' + S.map(function (s, i) {
      return '<div class="ucl-hs"><b>0' + (i + 1) + '</b><div><h4>' + s[0] + '</h4><p>' + s[1] + '</p></div></div>';
    }).join('');
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }
  function money(c, cur) { return (cur || '$') + (c / 100).toFixed(2); }

  /* ---------- prize photos: cut each product out of its white background ---------- */
  function cutout(src) {
    return new Promise(function (res) {
      var im = new Image(); im.crossOrigin = 'anonymous'; im.decoding = 'async';
      im.onload = function () { setTimeout(function () { try { res(cutImg(im)); } catch (e) { res(null); } }, 0); };
      im.onerror = function () { res(null); };
      im.src = src;
    });
  }
  function cutImg(im) {
    var M = 360, sc = Math.min(1, M / Math.max(im.naturalWidth, im.naturalHeight)),
        w = Math.max(1, Math.round(im.naturalWidth * sc)), h = Math.max(1, Math.round(im.naturalHeight * sc));
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var g = c.getContext('2d', { willReadFrequently: true }); g.drawImage(im, 0, 0, w, h);
    var d = g.getImageData(0, 0, w, h), p = d.data, N = w * h, bg = new Uint8Array(N), st = new Int32Array(N), sp = 0, i, x, y, k;
    function white(j) { var o = j * 4, r = p[o], gg = p[o + 1], b = p[o + 2], mn = Math.min(r, gg, b), mx = Math.max(r, gg, b); return p[o + 3] < 24 || (mn > 246 && mx - mn < 10); }   /* only near-pure white is background, so white leather and soles stay */
    function push(j) { if (!bg[j] && white(j)) { bg[j] = 1; st[sp++] = j; } }
    for (x = 0; x < w; x++) { push(x); push((h - 1) * w + x); }
    for (y = 0; y < h; y++) { push(y * w); push(y * w + w - 1); }
    while (sp) { i = st[--sp]; x = i % w; if (x > 0) push(i - 1); if (x < w - 1) push(i + 1); if (i >= w) push(i - w); if (i < N - w) push(i + w); }
    var nbg = 0; for (i = 0; i < N; i++) nbg += bg[i];
    if (nbg < N * .12) return null;                       /* not a white-background shot: skip it */
    var lab = new Int32Array(N), id = 0, best = 0, bestN = 0, bb = null;
    for (i = 0; i < N; i++) {
      if (bg[i] || lab[i]) continue;
      id++; var n = 0, x0 = w, y0 = h, x1 = 0, y1 = 0; sp = 0; st[sp++] = i; lab[i] = id;
      while (sp) {
        k = st[--sp]; var kx = k % w, ky = (k / w) | 0; n++;
        if (kx < x0) x0 = kx; if (kx > x1) x1 = kx; if (ky < y0) y0 = ky; if (ky > y1) y1 = ky;
        if (kx > 0 && !bg[k - 1] && !lab[k - 1]) { lab[k - 1] = id; st[sp++] = k - 1; }
        if (kx < w - 1 && !bg[k + 1] && !lab[k + 1]) { lab[k + 1] = id; st[sp++] = k + 1; }
        if (k >= w && !bg[k - w] && !lab[k - w]) { lab[k - w] = id; st[sp++] = k - w; }
        if (k < N - w && !bg[k + w] && !lab[k + w]) { lab[k + w] = id; st[sp++] = k + w; }
      }
      if (n > bestN) { bestN = n; best = id; bb = [x0, y0, x1, y1]; }
    }
    if (!bb || bestN < N * .04) return null;
    for (i = 0; i < N; i++) {
      if (lab[i] !== best) { p[i * 4 + 3] = 0; continue; }
      x = i % w;                                          /* soften the outline by one pixel */
      if ((x > 0 && bg[i - 1]) || (x < w - 1 && bg[i + 1]) || (i >= w && bg[i - w]) || (i < N - w && bg[i + w])) p[i * 4 + 3] = 140;
    }
    g.putImageData(d, 0, 0);
    var cw = bb[2] - bb[0] + 1, ch = bb[3] - bb[1] + 1, o = document.createElement('canvas'); o.width = cw; o.height = ch;
    o.getContext('2d').drawImage(c, bb[0], bb[1], cw, ch, 0, 0, cw, ch);
    /* a small see-through map of the piece, so the claw only grabs what it actually touches */
    var mw = 48, mh = Math.max(1, Math.round(mw * ch / cw)), mc = document.createElement('canvas'); mc.width = mw; mc.height = mh;
    var mg = mc.getContext('2d'); mg.drawImage(o, 0, 0, mw, mh); var md = mg.getImageData(0, 0, mw, mh).data, mk = new Uint8Array(mw * mh);
    for (i = 0; i < mw * mh; i++) mk[i] = md[i * 4 + 3] > 110 ? 1 : 0;
    return { url: o.toDataURL('image/png'), a: ch / cw, mask: { w: mw, h: mh, d: mk } };
  }
  var BRANDS = ["Jordan 4's", 'Jordan 4s', 'Air Jordan 3', 'Air Jordan 4', 'Jordan 1 Low', 'Jordan 4', 'Jordan 3', 'Jordan 6', 'Jordan 11', 'Jordan 1', 'Travis Scott', 'Denim Tears', 'Chrome Hearts', 'Broken Planet', 'Palm Angels', 'Ralph Lauren', 'Syna World', 'Trapstar', 'Sp5der', 'Corteiz', 'Hellstar', 'Moncler', 'Amiri', 'Nike', 'Adidas', 'Syna'];
  function split(title) {
    var t = String(title || '').replace(/\s+/g, ' ').trim();
    for (var i = 0; i < BRANDS.length; i++) if (t.toLowerCase().indexOf(BRANDS[i].toLowerCase()) === 0) {
      var rest = t.slice(BRANDS[i].length).replace(/^\s*[-–·:]?\s*/, '').replace(/^Retro\s*-\s*/i, '');
      return [BRANDS[i], rest || t];
    }
    return ['Urban.Leb', t];
  }
  /* Two neat rows on a 320px-wide glass, every piece in its own spot so each one can be picked:
     tops and pants stand on a raised step at the back, kicks sit on the floor in front.
     The joystick moves the claw left/right and front/back (which row it drops into). */
  var GW = 320, CHUTE = 66, ROW_B = [8, 86];               /* floor height of the front row, the back step */
  function kind(a) { return a < .8 ? 'shoe' : (a > 1.55 ? 'pants' : 'top'); }
  function layout(list) {
    /* back step: up to three tops and two pairs of pants, pants in between the tops; front: four kicks */
    var tops = list.filter(function (p) { return p.t === 'top'; }), pants = list.filter(function (p) { return p.t === 'pants'; }),
        front = list.filter(function (p) { return p.t === 'shoe'; }).slice(0, 4), T = tops.slice(0, 3), P = pants.slice(0, 2), back = [];
    var spare = tops.slice(3).concat(pants.slice(2));
    while (T.length + P.length < 5 && spare.length) { var sp = spare.shift(); (sp.t === 'pants' ? P : T).push(sp); }
    while (T.length || P.length) { if (T.length) back.push(T.shift()); if (P.length) back.push(P.shift()); }
    while (front.length < 4 && spare.length) front.push(spare.shift());
    var out = [], WT = { top: 1.2, pants: .7, shoe: 1 };
    function place(row, r) {
      var x0 = 8, x1 = GW - CHUTE - 10, tot = 0, at = x0;
      row.forEach(function (p) { tot += WT[p.t] || 1; });
      row.forEach(function (p, i) {
        var q = {}; for (var k in p) q[k] = p[k];
        var zw = (x1 - x0) * (WT[p.t] || 1) / Math.max(tot, 1);
        var maxW = p.t === 'shoe' ? 86 : p.t === 'pants' ? 44 : 80, maxH = r ? 112 : 66;
        q.row = r; q.l = r ? 0 : 2; q.z0 = at; q.z1 = at + zw; q.cx = at + zw / 2; at += zw;
        q.w = Math.min(zw * (p.t === 'pants' ? 1.15 : 1.25), maxW, maxH / p.a); q.b = ROW_B[r]; q.r = (i % 2 ? 1 : -1) * (2 + (i * 5) % 4);
        out.push(q);
      });
    }
    place(back, 1); place(front, 0);
    return out;
  }

  function Machine(root) {
    var data = {}; try { data = JSON.parse(root.querySelector('script[type="application/json"]').textContent); } catch (e) { return; }
    var PR = [], codes = data.codes || {}, ready = false;
    var seal = data.seal || SEAL;
    root.insertAdjacentHTML('beforeend', shell(data, seal));
    if (seal) { root.classList.add('sealcoin'); root.style.setProperty('--seal', 'url("' + seal + '")'); }   /* the wax seal is the claw coin */
    var q = function (s) { return root.querySelector(s); };
    var fit = q('.ucl-fit'), cab = q('.ucl-cab'), glass = q('.ucl-glass'), pile = q('.ucl-pile'), rig = q('.ucl-rig'), cable = q('.ucl-cable'),
        head = q('.ucl-claw'), car = q('.ucl-car'), laser = q('.ucl-beam'), msg = q('[data-m]'), timeEl = q('[data-t]'), timeBox = q('[data-tb]'),
        triesEl = q('.ucl-tries'), coin = q('.ucl-coin'), slotL = q('[data-sl]'), dropBtn = q('.ucl-drop'), joy = q('.ucl-joy'), stick = q('.ucl-stick'),
        tkw = q('.ucl-tkw'), tk = q('.ucl-tk'), leftN = q('[data-n]'), fx = q('.ucl-fx'), mute = q('.ucl-mute'), mark = q('.ucl-mark'), step = q('.ucl-step'), wallet = q('[data-w]');

    /* ---------- coins: 1 free a month + 1 for every $200 spent that month (counted by the theme from the
       customer's orders). Coins played are remembered on this device; coins whose prize code was already
       used at checkout count as spent everywhere. No coin data = demo mode, always playable. ---------- */
    var CO = data.coins || null, usedKey = CO && CO.logged ? 'ucl_used_' + CO.cid + '_' + CO.month : '';
    /* Visitors who aren't signed in get one play a month, counted in this browser (the theme sends
       cid 'g' for them, so the key is ucl_used_g_<month>). They see the prize and an email box where
       the code would be; signed-in customers get the code straight away. */
    var GUEST = !!(CO && CO.guest), claimed = false;
    if (GUEST) { try { claimed = !!localStorage.getItem('ucl_mail'); } catch (e) {} }
    function localUsed() { try { return parseInt(localStorage.getItem(usedKey) || '0', 10) || 0; } catch (e) { return 0; } }
    function coinsLeft() { if (!CO) return 1; if (!CO.logged) return 0; return Math.max(0, (CO.total || 0) - Math.max(CO.redeemed || 0, localUsed())); }
    function spendCoin() { if (!CO || !CO.logged) return; try { localStorage.setItem(usedKey, String(localUsed() + 1)); } catch (e) {} paintWallet(); }
    /* the word joiner after "$" keeps the site's currency switcher from rewriting "$200" as "$200.00" */
    function dollars(c) { return '$⁠' + Math.max(0, Math.ceil((c || 0) / 100)); }
    function paintMini() {
      var mw = q('[data-mw]'), ms = q('[data-ms]'), mb = q('[data-mb]'); if (!mw) return;
      if (!CO) { mw.innerHTML = ''; ms.textContent = 'Three pulls · win up to ' + (data.maxOff || 15) + '% off'; mb.style.width = '0'; return; }
      var per = CO.per || 20000;
      if (!CO.logged) {
        mw.innerHTML = '<a class="ucl-mq-btn" href="' + esc(CO.login) + '">Log in →</a>';
        ms.textContent = 'Free coin monthly · +1 per $⁠' + Math.round(per / 100) + ' spent'; mb.style.width = '0'; return;
      }
      if (GUEST) {
        var gl = coinsLeft();
        mw.innerHTML = gl > 0 ? '<span class="ucl-mq-c"></span><b>1</b><small>free play</small>'
          : '<a class="ucl-mq-btn" href="' + esc(CO.login) + '">Sign in →</a>';
        ms.textContent = gl > 0 ? 'Your free play · sign in for a coin every month'
          : 'Sign in for a coin every month · +1 per $⁠' + Math.round(per / 100) + ' spent';
        mb.style.width = '0'; return;
      }
      var left = coinsLeft(), pct = clamp((per - (CO.toNext || per)) / per, 0, 1);
      mw.innerHTML = left <= 0 && data.practice !== false ? '<button class="ucl-mq-btn line" type="button" data-practice>Practice ▸</button>'   /* out of coins: offer a practice round instead */
        : '<span class="ucl-mq-c' + (left ? '' : ' off') + '"></span><b>' + left + '</b><small>coin' + (left === 1 ? '' : 's') + '</small>';
      ms.textContent = dollars(CO.toNext) + ' more this month = +1 coin · refills ' + (CO.reset || '');
      mb.style.width = (pct * 100).toFixed(1) + '%';
    }
    function paintWallet() {
      paintMini();
      if (!wallet || !CO) return;
      if (!CO.logged) {
        wallet.innerHTML = '<div class="ucl-w-row"><span class="ucl-w-t">A free coin every month</span><a class="ucl-w-btn" href="' + esc(CO.login) + '">Log in to play →</a></div>'
          + '<div class="ucl-w-s">+1 coin for every $⁠' + Math.round((CO.per || 20000) / 100) + ' you spend in a month</div>';
        return;
      }
      if (GUEST) {
        var gleft = coinsLeft();
        wallet.innerHTML = '<div class="ucl-w-row"><span class="ucl-w-t">' + (gleft ? '<b>1</b> free play' : 'Free play used') + '</span>'
          + '<a class="ucl-w-btn" href="' + esc(CO.login) + '">Sign in →</a></div>'
          + '<div class="ucl-w-s"><span>Signed in: a coin every month</span><span>+1 per $⁠' + Math.round((CO.per || 20000) / 100) + ' spent</span></div>';
        return;
      }
      var left = coinsLeft(), per = CO.per || 20000, pct = clamp((per - (CO.toNext || per)) / per, 0, 1), dots = '';
      for (var i = 0; i < Math.max(1, Math.min(left, 6)); i++) dots += '<i' + (left ? '' : ' class="off"') + '></i>';
      wallet.innerHTML = '<div class="ucl-w-row"><span class="ucl-w-coins">' + dots + '</span><span class="ucl-w-t"><b>' + left + '</b> coin' + (left === 1 ? '' : 's') + ' left</span></div>'
        + '<div class="ucl-w-bar"><i style="width:' + (pct * 100).toFixed(1) + '%"></i></div>'
        + '<div class="ucl-w-s"><span>' + dollars(CO.toNext) + ' more this month = +1 coin</span><span>Free coin refills ' + esc(CO.reset || '') + '</span></div>'
        + (left <= 0 && data.practice !== false ? '<div class="ucl-w-acts"><a class="ucl-w-btn" href="' + esc(data.shopAll || '/collections/all') + '">Shop to earn a coin →</a><button class="ucl-w-btn line" type="button" data-practice>Practice ▸</button></div>' : '');
    }
    var practice = false;                                   /* out of coins: play for fun, no prize code */
    root.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-practice]')) { practice = true; insertCoin(); } });
    var tks = root.querySelectorAll('[data-tk]');
    function setTick(t) { [].forEach.call(tks, function (e) { e.textContent = t; }); }
    var TICK = 'URBAN.LEB ✦ THE CLAW ✦ 3 PULLS A GAME ✦ WIN A PIECE ✦ ';
    setTick(TICK + TICK);
    mute.setAttribute('aria-pressed', muted ? 'true' : 'false');
    mute.addEventListener('click', function () { muted = !muted; mute.setAttribute('aria-pressed', muted ? 'true' : 'false'); try { localStorage.setItem('ucl_mute', muted ? '1' : '0'); } catch (e) {} if (muted) humOff(); else if (state === 'play') { humOn(); } });

    /* scale the 340px design box to the sheet it sits on */
    var S = 1;
    /* keep the headline clear of the site's fixed header (measured, since its height changes with the announcement bar) */
    function clearHeader() {
      if (!root.closest('.ulth-face,.ucl-page')) return;
      var hb = 0;
      [].forEach.call(document.querySelectorAll('header,[class*="header"],[class*="announcement"],[id*="header"]'), function (el) {
        if (root.contains(el) || el.contains(root)) return;
        var cs = getComputedStyle(el); if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
        /* any full-width bar pinned near the top (the header sits under the announcement bar, so not always at 0) */
        var r = el.getBoundingClientRect(); if (r.width > innerWidth * .6 && r.height < innerHeight / 4 && r.top < innerHeight / 5 && r.bottom > hb) hb = r.bottom;
      });
      /* the theme also says how tall its bars are: never sit higher than that */
      var ds = getComputedStyle(document.documentElement), vh = (parseFloat(ds.getPropertyValue('--nav-h')) || 0) + (parseFloat(ds.getPropertyValue('--ann-h')) || 0);
      if (vh > hb && vh < innerHeight / 3) hb = vh;
      /* on the homepage the sheet's torn top edge dips lower on wide screens: stay under it too */
      if (root.closest('.ulth-face')) hb = Math.max(hb, root.clientHeight * (.08 + .055 * innerWidth / Math.max(1, innerHeight)) - 4);
      if (hb) root.style.paddingTop = Math.round(hb + (root.clientWidth >= 700 ? 16 : 10)) + 'px';
    }
    /* layout by the room the machine has: phones stack (headline over the machine); mid widths put the
       headline and prize board beside it; computers get how-it-works | machine | prize board */
    var mode = '';
    function setMode() {
      var w = root.clientWidth, m = w >= 1080 ? 'w3' : (w >= 700 ? 'w2' : 'n');
      root.classList.toggle('short', m === 'n' && root.clientHeight < 760);   /* short phone screens: an even tighter headline */
      if (m === mode) return;
      root.classList.remove('w2', 'w3'); if (m !== 'n') root.classList.add(m); root.classList.toggle('wide', m !== 'n'); mode = m;
    }
    function scaleFit() {
      clearHeader(); setMode();
      var pad = parseFloat(getComputedStyle(root).paddingTop) || 0, wide = mode !== 'n';
      var aw = root.clientWidth - (wide ? 72 : 12), ah = root.clientHeight - pad - (wide ? 28 : 6), nw = fit.offsetWidth, nh = fit.offsetHeight;
      S = Math.min(wide ? 1.45 : 1.4, aw / nw, ah > 200 ? ah / nh : 1);
      var off = Math.max(0, (ah - nh * S) / 2);          /* centre it in the space left under the header */
      fit.style.transform = (off ? 'translateY(' + off.toFixed(1) + 'px) ' : '') + 'scale(' + S.toFixed(3) + ')';
    }

    var W, H, K, items = [];
    function buildPile() {
      pile.innerHTML = ''; items = [];
      W = glass.clientWidth; H = glass.clientHeight; K = W / GW;
      step.style.height = (ROW_B[1] * K - 4) + 'px'; step.style.right = (CHUTE * K + 4) + 'px';
      PR.forEach(function (p) {
        var im = new Image(); im.src = p.img; im.alt = p.brand + ' ' + p.name; im.draggable = false;
        im.className = 'ucl-prize l' + p.l + (p.j ? ' jp' : '');
        var w = p.w * K; im.style.width = w + 'px'; im.style.left = (p.cx * K - w / 2) + 'px'; im.style.bottom = (p.b * K) + 'px';
        im.style.transform = 'rotate(' + p.r + 'deg)';
        pile.appendChild(im);
        var it = { el: im, p: p, r: p.r, taken: false, tx: 0, ty: 0, w: w, h: w * p.a, left: p.cx * K - w / 2, top: H - p.b * K - w * p.a, z0: p.z0 * K, z1: p.z1 * K };
        if (p.j) { var t = document.createElement('span'); t.className = 'ucl-jtag'; t.textContent = '★ JACKPOT ' + (codes.jackpotOff || data.maxOff || 15) + '%'; t.style.left = Math.max(2, p.cx * K - 36) + 'px'; t.style.bottom = (p.b * K + w * p.a + 4) + 'px'; pile.appendChild(t); it.tag = t; }
        items.push(it);
      });
      leftN.textContent = PR.length;

    }

    var RIG_TOP = 26, L0 = 14, L = L0, x = 0, prevX = 0, vx = 0, sway = 0, swayV = 0, input = 0, SPEED = 150, z = 0, zIn = 0, zT = null;
    function sc() { return 1 - .14 * z; }                          /* the claw looks smaller further back */
    function row() { return z >= .5 ? 1 : 0; }
    var state = 'idle', tries = 3, time = 20, timer = null, carry = null, running = false, last = 0, aimX = -99, aimed = null;
    var HOME = function () { return W * .36; };

    function render() {
      var k = sc();
      rig.style.transform = 'translateX(' + x.toFixed(1) + 'px) rotate(' + sway.toFixed(2) + 'deg) scale(' + k.toFixed(3) + ')';
      mark.style.transform = 'translate(' + x.toFixed(1) + 'px,' + (H - (ROW_B[0] + (ROW_B[1] - ROW_B[0]) * z) * K).toFixed(1) + 'px) scale(' + k.toFixed(3) + ')';
      car.style.transform = 'translateX(' + x.toFixed(1) + 'px)';
      laser.style.transform = 'translateY(' + (L + 50).toFixed(1) + 'px)';
      cable.style.transform = 'scaleY(' + L.toFixed(1) + ')';
      head.style.transform = 'translateY(' + L.toFixed(1) + 'px)';
      if (carry) {
        var s = sway * Math.PI / 180, ly = (L + carry.offY) * k, rx = carry.offX * Math.cos(s) - ly * Math.sin(s), ry = carry.offX * Math.sin(s) + ly * Math.cos(s);
        carry.tx = x + rx - carry.cx0; carry.ty = RIG_TOP + ry - carry.cy0;
        carry.el.style.transform = 'translate(' + carry.tx.toFixed(1) + 'px,' + carry.ty.toFixed(1) + 'px) rotate(' + (carry.rNow + sway).toFixed(1) + 'deg)';
      }
      if (state === 'play') aimAt(target());
    }
    function aimAt(it) {
      if (aimed === it) return;
      if (aimed) aimed.el.classList.remove('aim');
      aimed = it || null;
      if (aimed) { aimed.el.classList.add('aim'); SFX.tick(); }
      head.classList.toggle('lock', !!aimed); laser.classList.toggle('lock', !!aimed);
    }
    function clearAim() { if (aimed) aimed.el.classList.remove('aim'); aimed = null; head.classList.remove('lock'); laser.classList.remove('lock'); aimX = -99; }

    /* ---------- attract mode: while nobody plays and it's on screen, the claw drifts over the pieces ---------- */
    var fxo = data.fx || {}, attract = !!fxo.attract && !reduce, live = false;
    function idleMove(ts) {
      var t = ts / 1000;
      x = W * .42 + Math.sin(t * .55) * W * .3 + Math.sin(t * 1.3) * W * .04;
      z = .5 + .5 * Math.sin(t * .31);
    }
    function loop(ts) {
      var dt = Math.min(.05, (ts - last) / 1000 || 0); last = ts;
      if (state === 'idle' && attract && ready) { if (!live) { running = false; return; } idleMove(ts); }
      if (state === 'play' && input) x = clamp(x + input * SPEED * dt, 30, W - 30);
      if (state === 'play' && zIn) { z = clamp(z + zIn * 2.4 * dt, 0, 1); zT = null; }
      else if (state === 'play' && zT !== null) { z += (zT - z) * Math.min(1, dt * 12); if (Math.abs(zT - z) < .01) { z = zT; zT = null; } }
      if (dt > 0) {
        var v = (x - prevX) / dt, a = clamp((v - vx) / dt, -4000, 4000); vx = v; prevX = x;
        swayV += (-a * .011 - 70 * sway - 7 * swayV) * dt; sway = clamp(sway + swayV * dt, -16, 16);
      }
      render();
      if (running) requestAnimationFrame(loop);
    }
    function startLoop() { if (running) return; running = true; last = performance.now(); requestAnimationFrame(loop); }
    function stopLoop() { running = false; }
    function wait(ms) { return new Promise(function (r) { setTimeout(r, reduce ? Math.min(ms, 80) : ms); }); }
    var easeIO = function (t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
    function tween(ms, fn, ease) {
      ease = ease || easeIO; if (reduce) ms = Math.min(ms, 160);
      return new Promise(function (res) { var t0 = performance.now(); (function f(now) { var t = Math.min(1, (now - t0) / ms); fn(ease(t)); if (t < 1) requestAnimationFrame(f); else res(); })(t0); });
    }
    function say(text, sub, tone_, keep) {
      msg.innerHTML = esc(text) + (sub ? '<small>' + esc(sub) + '</small>' : '');
      msg.classList.remove('red', 'gold', 'blink'); if (tone_) msg.classList.add(tone_); msg.classList.add('on');
      clearTimeout(say.t); if (!keep) say.t = setTimeout(function () { msg.classList.remove('on'); }, 1200);
    }
    function pick(a) { return a[Math.floor(Math.random() * a.length)]; }
    function idleMsg() {
      var left = coinsLeft();
      if (CO && !CO.logged) { msg.innerHTML = 'Log in to play<small>Your free coin is waiting</small>'; slotL.textContent = 'Log in'; }
      else if (GUEST && left <= 0) { msg.innerHTML = 'Free play used<small>Sign in for a coin every month</small>'; slotL.textContent = 'Sign in'; }
      else if (left <= 0) { msg.innerHTML = 'Out of coins<small>' + (data.practice !== false ? 'Practice for fun · or shop to earn one' : esc(dollars(CO.toNext)) + ' more this month earns one') + '</small>'; slotL.textContent = 'No coins'; }
      else { msg.innerHTML = 'Insert coin<small>Tap the coin to play</small>'; slotL.textContent = CO ? left + ' coin' + (left === 1 ? '' : 's') : 'Insert coin'; }
      slotL.classList.add('blink'); root.classList.toggle('locked', !!CO && left <= 0);
      msg.classList.remove('red', 'gold'); msg.classList.add('on', 'blink');
    }
    function paintTries() { [].forEach.call(triesEl.children, function (d, i) { d.classList.toggle('used', i >= tries); }); }
    function paintTime() { timeEl.textContent = '00:' + (time < 10 ? '0' : '') + time; timeBox.classList.toggle('hot', time <= 5 && state === 'play'); }
    function startTimer() {
      clearInterval(timer); time = 20; paintTime();
      timer = setInterval(function () { if (state !== 'play') return; time--; paintTime(); if (time <= 5 && time > 0) SFX.tick(); if (time <= 0) { clearInterval(timer); drop(); } }, 1000);
    }
    function shake() { cab.classList.remove('shake'); void cab.offsetWidth; cab.classList.add('shake'); }

    function insertCoin() {
      if (state !== 'idle' || !ready) return;
      if (CO && !CO.logged) { location.href = CO.login; return; }
      if (coinsLeft() <= 0 && !practice) { shake(); SFX.slip(); buzz(30); return; }
      if (!practice) spendCoin();
      state = 'coin'; root.classList.toggle('practice', practice); coin.classList.add('in'); slotL.classList.remove('blink'); slotL.textContent = practice ? 'Practice' : '1 credit'; SFX.coin(); buzz(15);
      wait(480).then(function () { coin.classList.add('gone'); begin(); });
    }
    function begin() {
      state = 'play'; root.classList.add('playing'); startLoop(); startTimer(); paintTries(); humOn(); aimX = -99; zT = 0;   /* every game starts on the front row */
      say(practice ? 'Practice.' : 'Go.', practice ? 'Just for fun · no code' : 'Joystick up = back row · down = front'); SFX.go();
    }
    coin.addEventListener('click', insertCoin);

    /* joystick */
    var jd = false;
    function setInput(v, vz) {
      vz = vz || 0; input = v; zIn = vz;
      stick.style.transform = 'rotate(' + (v * 24).toFixed(1) + 'deg) scaleY(' + (1 + vz * .16).toFixed(3) + ')';
      joy.setAttribute('aria-valuenow', v.toFixed(2)); humLevel(state === 'play' && (v !== 0 || vz !== 0));
    }
    function dz(v) { return Math.abs(v) < .28 ? 0 : v; }                /* small dead zone so left/right doesn't drift front/back */
    function joyAt(e) { var r = joy.getBoundingClientRect(), k = r.width / joy.offsetWidth || S; setInput(dz(clamp((e.clientX - (r.left + r.width / 2)) / (24 * k), -1, 1)), dz(clamp(-(e.clientY - (r.top + r.height / 2)) / (24 * k), -1, 1))); }
    joy.addEventListener('pointerdown', function (e) { jd = true; joy.setPointerCapture(e.pointerId); if (state === 'idle' && coinsLeft() > 0) insertCoin(); joyAt(e); });
    joy.addEventListener('pointermove', function (e) { if (jd) joyAt(e); });
    function joyUp() { jd = false; setInput(0, 0); }
    joy.addEventListener('pointerup', joyUp); joy.addEventListener('pointercancel', joyUp);
    joy.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); if (state === 'idle') insertCoin(); setInput(e.key === 'ArrowLeft' ? -1 : 1, 0); }
      else if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); if (state === 'idle') insertCoin(); setInput(0, e.key === 'ArrowUp' ? 1 : -1); }
      else if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); press(); }
    });
    joy.addEventListener('keyup', function (e) { if (/^Arrow/.test(e.key)) setInput(0, 0); });

    /* swipe the glass sideways to steer (vertical swipes still scroll the page) */
    var gx = null, gx0 = 0;
    glass.addEventListener('pointerdown', function (e) { if (state !== 'play') return; gx = e.clientX; gx0 = x; });
    glass.addEventListener('pointermove', function (e) { if (gx === null || state !== 'play') return; var k = glass.getBoundingClientRect().width / glass.clientWidth || S; x = clamp(gx0 + (e.clientX - gx) / k, 30, W - 30); humLevel(true); });
    function gUp() { if (gx !== null) { gx = null; humLevel(false); } }
    glass.addEventListener('pointerup', gUp); glass.addEventListener('pointercancel', gUp); glass.addEventListener('pointerleave', gUp);

    function rel(el) { var g = glass.getBoundingClientRect(), r = el.getBoundingClientRect(), k = g.width / glass.clientWidth || S; return { t: (r.top - g.top) / k, w: r.width / k, h: r.height / k, cx: (r.left - g.left + r.width / 2) / k, cy: (r.top - g.top + r.height / 2) / k }; }
    /* which piece the claw will drop onto: the one whose spot it is over, in the row it is set to */
    function target() {
      var R = row();
      for (var i = 0; i < items.length; i++) { var it = items[i]; if (!it.taken && it.p.row === R && x >= it.z0 && x < it.z1) return it; }
      return null;
    }
    function solid(it, px, py) {
      var cx = it.left + it.w / 2 + it.tx, cy = it.top + it.h / 2 + it.ty, r = it.r * Math.PI / 180, dx = px - cx, dy = py - cy;
      var lx = dx * Math.cos(r) + dy * Math.sin(r) + it.w / 2, ly = -dx * Math.sin(r) + dy * Math.cos(r) + it.h / 2;
      if (lx < 0 || ly < 0 || lx >= it.w || ly >= it.h) return false;
      var m = it.p.mask; if (!m) return true;
      return m.d[Math.floor(ly / it.h * m.h) * m.w + Math.floor(lx / it.w * m.w)] === 1;
    }
    function landY(it) {                                   /* where the fabric starts under the claw */
      for (var y = it.top - 4; y < it.top + it.h; y += 2) if (solid(it, x, y) || solid(it, x - 6, y) || solid(it, x + 6, y)) return y;
      return it.top + it.h * .3;
    }
    function press() {
      dropBtn.classList.add('press'); setTimeout(function () { dropBtn.classList.remove('press'); }, 120);
      if (state === 'idle') insertCoin(); else if (state === 'play') drop();
    }
    dropBtn.addEventListener('click', press);

    function drop() {
      if (state !== 'play') return;
      state = 'busy'; root.classList.remove('playing'); clearInterval(timer); timeBox.classList.remove('hot'); setInput(0, 0); humLevel(false); buzz(20);
      var touch = target(), hit = touch ? { it: touch, b: rel(touch.el) } : null, result, slipped = false, wob = 0, k = sc();
      var floorL = (H - 12 - RIG_TOP) / k - 54, L1 = touch ? clamp((landY(touch) - RIG_TOP) / k - 54 + 10, 20, floorL) : floorL;
      clearAim(); head.classList.add('open');
      wait(160).then(function () {
        SFX.drop();
        return tween(1000, function (t) { L = L0 + (L1 - L0) * t; }, function (t) { return 1 - Math.pow(1 - t, 2); });
      }).then(function () {
        head.classList.remove('open'); SFX.clunk(); buzz(35); shake();
        return wait(360);
      }).then(function () {
        result = 'miss';
        if (hit) {                                         /* dead centre almost always holds; the jackpot is harder */
          var d = Math.abs(hit.b.cx - x), jp = !!hit.it.p.j;
          result = d < hit.b.w * (jp ? .14 : .22) + (jp ? 6 : 10) ? 'win' : (Math.random() < (jp ? .25 : .45) ? 'win' : 'slip');
        }
        if (result !== 'miss') attach(hit);
        SFX.up();
        return tween(1150, function (t) {
          L = L1 + (L0 - L1) * t;
          if (result === 'slip' && !slipped && t > .52) { slipped = true; fallBack(); }
          if (carry) { carry.offX *= .94; carry.rNow += (carry.r * .3 - carry.rNow) * .08;
            if (result === 'slip' && t > .26) { carry.rNow += Math.sin(t * 90) * 2.2; if (!wob) { wob = 1; buzz([8, 30, 8, 30, 8]); } } }
        });
      }).then(function () {
        if (result === 'win') {
          var cx = W - CHUTE * K / 2 - 6, x1 = x, z1 = z; humOn(); humLevel(true);
          return tween(950, function (t) { x = x1 + (cx - x1) * t; z = z1 * (1 - t); }).then(function () { humLevel(false); return wait(240); }).then(function () {
            head.classList.add('open'); buzz(40); var won = carry; release(won); return wait(560).then(function () { return won.it; });
          }).then(winRound);
        }
        tries--; paintTries(); SFX.slip();
        say(result === 'slip' ? pick(['So close.', 'Butterfingers.', 'Almost had it.']) : pick(['Missed.', 'Air ball.', 'Nothing.']), tries > 0 ? (tries + (tries > 1 ? ' pulls' : ' pull') + ' left') : 'Out of pulls', 'red');
        var x2 = x, hx = HOME();
        return wait(500).then(function () { head.classList.add('open'); return tween(800, function (t) { x = x2 + (hx - x2) * t; }); }).then(function () {
          if (tries > 0) { state = 'play'; root.classList.add('playing'); startTimer(); aimed = null; }
          else return wait(500).then(consolation);
        });
      });
    }
    function attach(hit) {
      var it = hit.it, b = hit.b; it.taken = true; it.el.classList.add('carry'); if (it.tag) it.tag.style.opacity = 0;
      carry = { it: it, el: it.el, cx0: b.cx - it.tx, cy0: b.cy - it.ty, offX: b.cx - x, offY: (b.cy - RIG_TOP) / sc() - L, r: it.r, rNow: it.r, tx: it.tx, ty: it.ty };
    }
    function fallBack() {
      var c = carry; carry = null; c.it.taken = false;
      var tx0 = c.tx, ty0 = c.ty, r0 = c.rNow;
      tween(620, function (t) {
        var k = t < .7 ? t / .7 : 1 - Math.sin((t - .7) / .3 * Math.PI) * .06;
        c.it.tx = tx0 * (1 - k); c.it.ty = ty0 * (1 - k);
        c.el.style.transform = 'translate(' + c.it.tx.toFixed(1) + 'px,' + c.it.ty.toFixed(1) + 'px) rotate(' + (r0 + (c.it.r - r0) * t).toFixed(1) + 'deg)';
      }, function (t) { return t * t; }).then(function () { c.el.classList.remove('carry'); if (c.it.tag) c.it.tag.style.opacity = 1; SFX.thud(); shake(); });
      buzz(15);
    }
    function release(c) {
      carry = null; var tx0 = c.tx, ty0 = c.ty, r0 = c.rNow; c.el.style.zIndex = 4;
      return tween(560, function (t) {
        var ty = ty0 + (H + 40 - c.cy0 - ty0) * t;
        c.el.style.transform = 'translate(' + tx0.toFixed(1) + 'px,' + ty.toFixed(1) + 'px) rotate(' + (r0 + 40 * t).toFixed(1) + 'deg)';
        c.el.style.opacity = t > .7 ? (1 - (t - .7) / .3).toFixed(2) : 1;
      }, function (t) { return t * t; });
    }
    function winRound(it) {
      var jp = !!it.p.j;
      root.classList.add('party'); if (jp) root.classList.add('gold'); setTick(jp ? 'JACKPOT ✦ JACKPOT ✦ JACKPOT ✦ JACKPOT ✦ ' : 'WINNER ✦ WINNER ✦ WINNER ✦ WINNER ✦ ');
      setTimeout(function () { root.classList.remove('party'); }, 1800);
      SFX.win(); buzz([30, 40, 60]); confetti(jp);
      leftN.textContent = items.filter(function (i) { return !i.taken; }).length;
      say(jp ? 'Jackpot.' : 'Got it.', 'Your slip is printing', jp ? 'gold' : '', true);
      return wait(1000).then(function () {
        ticket(it.p, jp ? 'jackpot' : 'win'); state = 'done'; humOff();
        var x2 = x, hx = HOME(); tween(900, function (t) { x = x2 + (hx - x2) * t; }).then(function () { setTimeout(stopLoop, 600); });
      });
    }
    function consolation() {
      say('Game over', 'Here’s something anyway', 'red', true); humOff(); setTick('THANKS FOR PLAYING ✦ THANKS FOR PLAYING ✦ ');
      setTimeout(function () { ticket(null, 'miss'); }, 900);
      state = 'done'; setTimeout(stopLoop, 800);
    }

    /* confetti, only for the second after a win */
    function confetti(gold) {
      if (reduce) return;
      var dpr = Math.min(2, window.devicePixelRatio || 1), w = glass.clientWidth, h = glass.clientHeight;
      fx.width = w * dpr; fx.height = h * dpr; var c = fx.getContext('2d'); c.setTransform(dpr, 0, 0, dpr, 0, 0);
      var cols = gold ? ['#F4C35A', '#FFF1C2', '#FBFBF9', '#70CBFF'] : ['#FBFBF9', '#70CBFF', '#DFF5FF', '#1E2328'];
      var P = [];
      for (var i = 0; i < 80; i++) {                       /* torn scraps of paper, like the sheet */
        var n = 4 + (i % 2), s = 4 + Math.random() * 6, pts = [];
        for (var k = 0; k < n; k++) { var an = k / n * 6.283 + Math.random() * .6; pts.push([Math.cos(an) * s * (.6 + Math.random() * .5), Math.sin(an) * s * (.6 + Math.random() * .5)]); }
        P.push({ x: w - 44 + (Math.random() - .5) * 20, y: h - 96, vx: (Math.random() - .7) * 7.5, vy: -Math.random() * 9.5 - 3, r: Math.random() * 6, vr: (Math.random() - .5) * .3, f: Math.random() * 6, pts: pts, c: cols[i % 4] });
      }
      var t0 = performance.now();
      (function f(now) {
        var t = (now - t0) / 1000; c.clearRect(0, 0, w, h);
        P.forEach(function (p) {
          p.vy += .3; p.vx *= .99; p.x += p.vx; p.y += p.vy; p.r += p.vr; p.f += .22;
          c.save(); c.translate(p.x, p.y); c.rotate(p.r); c.scale(1, Math.cos(p.f)); c.globalAlpha = Math.max(0, 1 - t / 2); c.fillStyle = p.c;
          c.beginPath(); c.moveTo(p.pts[0][0], p.pts[0][1]); for (var k = 1; k < p.pts.length; k++) c.lineTo(p.pts[k][0], p.pts[k][1]); c.closePath(); c.fill();
          c.restore();
        });
        if (t < 2) requestAnimationFrame(f); else c.clearRect(0, 0, w, h);
      })(t0);
    }

    var MON = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    function bars(hh) {
      var W2 = 210, x2 = 7, on = true, r = '<rect x="0" width="2" height="46"/><rect x="4" width="1" height="46"/>';
      while (x2 < W2 - 9) { hh = (Math.imul(hh, 1664525) + 1013904223) >>> 0; var bw = 1 + ((hh >>> 24) % 3); if (on) r += '<rect x="' + x2 + '" width="' + bw + '" height="46"/>'; x2 += bw; on = !on; }
      r += '<rect x="' + (W2 - 5) + '" width="1" height="46"/><rect x="' + (W2 - 2) + '" width="2" height="46"/>';
      return '<svg class="ucl-tk-bars" viewBox="0 0 ' + W2 + ' 46" preserveAspectRatio="none" aria-hidden="true" fill="currentColor">' + r + '</svg>';
    }
    function ticket(p, kind) {
      if (practice) return practiceSlip(p);
      var now = new Date(), two = function (n) { return ('0' + n).slice(-2); };
      var stamp = two(now.getDate()) + ' ' + MON[now.getMonth()] + ' ' + now.getFullYear() + ' · ' + two(now.getHours()) + ':' + two(now.getMinutes());
      var order = kind === 'jackpot' ? ['jackpot', 'win', 'miss'] : kind === 'win' ? ['win', 'miss', 'jackpot'] : ['miss', 'win', 'jackpot'];
      var used = (CO && CO.used) || [], tier = order[0];               /* each code works once a month: skip one already used */
      for (var oi = 0; oi < order.length; oi++) { var cc = codes[order[oi]]; if (cc && used.indexOf(String(cc).toUpperCase()) < 0) { tier = order[oi]; break; } }
      var code = codes[tier] || 'CLAW', off = codes[tier + 'Off'] || 5, until = (CO && CO.until) || data.until || '';
      var cur = data.currency || '$', no = 1000 + Math.floor(Math.random() * 9000);
      var href = p ? p.url : (data.shopAll || '/collections/all'), shopHref = href;
      /* a visitor who isn't signed in gets the prize, and the code once they've left an email */
      var claim = GUEST && !claimed, codeCls = claim ? ' claim' : '';
      var codeInner = claim
        ? '<form class="ucl-cl" novalidate><input type="email" required autocomplete="email" inputmode="email" spellcheck="false" placeholder="your email" aria-label="Your email"><button type="submit" aria-label="Get the code">Get it</button></form>'
        : '<b>' + esc(code) + '</b>';
      if (data.apply && !claim) href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(href);
      var h = '<div class="ucl-tk-hd">' + (seal ? '<img class="ucl-tk-seal" src="' + esc(seal) + '" alt="">' : '') + '<div class="ucl-tk-t">Prize slip</div><div class="ucl-tk-s">The claw · urban.leb · beirut</div></div>'
        + '<div class="ucl-tk-meta"><span>No. ' + no + '</span><span>' + stamp + '</span></div><div class="ucl-tk-rule"></div>';
      if (p) {
        h += '<div class="ucl-tk-body"><img src="' + esc(p.img) + '" alt=""><div><div class="ucl-tk-b">' + esc(p.brand) + '</div><div class="ucl-tk-n">' + esc(p.name) + '</div>'
          + '<div class="ucl-tk-p"><s>' + money(p.price, cur) + '</s>' + money(Math.round(p.price * (100 - off) / 100), cur) + '</div></div>'
          + '<span class="ucl-stamp">' + (kind === 'jackpot' ? 'Jackpot' : 'Won') + '</span></div>'
          + '<div class="ucl-tk-rule"></div><div class="ucl-tk-code' + codeCls + '" data-code><span>' + off + '% off your order<br>' + (claim ? 'email for your code + first look at drops' : (until ? 'use by ' + esc(until) : 'this piece or anything')) + '</span>' + codeInner + '</div>';
      } else {
        h += '<div class="ucl-tk-body" style="display:block"><div class="ucl-tk-big">' + off + '% off<br>anything</div><span class="ucl-stamp">Played</span></div>'
          + '<div class="ucl-tk-rule"></div><div class="ucl-tk-code' + codeCls + '" data-code><span>Better luck next pull<br>' + (claim ? 'email for your code + first look at drops' : (until ? 'use by ' + esc(until) : 'good this month')) + '</span>' + codeInner + '</div>';
      }
      h += bars(no * 2654435761 >>> 0)
        + '<div class="ucl-tk-acts"><a class="ucl-btn ink" href="' + esc(href) + '">' + (p ? 'Cop it' : 'Shop now') + ' →</a><button class="ucl-btn line" type="button" data-again>' + (CO && coinsLeft() <= 0 ? 'Done' : 'Again') + '</button></div>';
      tk.innerHTML = h; SFX.print();
      tkw.classList.remove('on'); void tk.offsetWidth; tkw.classList.add('on');
      setTimeout(function () { SFX.clunk(); buzz(30); }, reduce ? 0 : 1650);
      tk.querySelector('[data-again]').addEventListener('click', reset);
      if (!claim) return;
      /* the email box on the slip: hand over the code, and add them to the shop's drop list */
      var cf = tk.querySelector('.ucl-cl'), cbox = tk.querySelector('[data-code]');
      if (!cf || !cbox) return;
      cf.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var inp = cf.querySelector('input'), em = String(inp.value || '').trim();
        if (!/^[^@\s]+@[^@\s.]+\.[^@\s]{2,}$/.test(em)) { cf.classList.add('bad'); inp.focus(); return; }
        cf.classList.remove('bad'); cf.classList.add('busy'); inp.blur();
        function show() {
          claimed = true; try { localStorage.setItem('ucl_mail', em); } catch (e2) {}
          cbox.className = 'ucl-tk-code';
          cbox.innerHTML = '<span>' + off + '% off your order<br>' + (until ? 'use by ' + esc(until) : 'good this month') + '</span><b>' + esc(code) + '</b>';
          var cta = tk.querySelector('.ucl-btn.ink');
          if (cta && data.apply) cta.setAttribute('href', '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(shopHref));
          SFX.print(); buzz(20);
        }
        var fd = new FormData();
        fd.append('form_type', 'customer'); fd.append('utf8', '✓');
        fd.append('contact[email]', em); fd.append('contact[tags]', 'the claw');
        fd.append('contact[accepts_marketing]', 'true');
        try { fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' }).then(show, show); }
        catch (e3) { show(); }
      });
    }
    function practiceSlip(p) {
      var h = '<div class="ucl-tk-hd">' + (seal ? '<img class="ucl-tk-seal" src="' + esc(seal) + '" alt="">' : '') + '<div class="ucl-tk-t">Practice slip</div><div class="ucl-tk-s">The claw · urban.leb · beirut</div></div><div class="ucl-tk-rule"></div>';
      h += p ? '<div class="ucl-tk-body"><img src="' + esc(p.img) + '" alt=""><div><div class="ucl-tk-b">' + esc(p.brand) + '</div><div class="ucl-tk-n">' + esc(p.name) + '</div><div class="ucl-tk-p">' + money(p.price, data.currency || '$') + '</div></div><span class="ucl-stamp">Practice</span></div>'
             : '<div class="ucl-tk-body" style="display:block"><div class="ucl-tk-big">Nothing<br>this time</div><span class="ucl-stamp">Practice</span></div>';
      h += '<div class="ucl-tk-rule"></div><div class="ucl-tk-code"><span>No code on practice rounds<br>' + (CO && CO.logged ? esc(dollars(CO.toNext)) + ' more this month = a real coin' : 'earn a coin to play for real') + '</span></div>'
        + '<div class="ucl-tk-acts"><a class="ucl-btn ink" href="' + esc(p ? p.url : (data.shopAll || '/collections/all')) + '">' + (p ? 'Shop it' : 'Shop now') + ' →</a><button class="ucl-btn line" type="button" data-again>Again</button></div>';
      tk.innerHTML = h; SFX.print();
      tkw.classList.remove('on'); void tk.offsetWidth; tkw.classList.add('on');
      setTimeout(function () { SFX.clunk(); buzz(30); }, reduce ? 0 : 1650);
      tk.querySelector('[data-again]').addEventListener('click', reset);
    }
    function reset() {
      practice = false; root.classList.remove('practice');
      tkw.classList.remove('on'); msg.classList.remove('on'); root.classList.remove('gold'); setTick(TICK + TICK);
      setTimeout(function () {
        buildPile(); tries = 3; paintTries(); time = 20; paintTime();
        coin.classList.remove('in', 'gone');
        x = prevX = HOME(); L = L0; z = 0; sway = swayV = 0; head.classList.add('open'); render(); idleMsg(); state = 'idle';
        if (attract && live) startLoop();
      }, 350);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) {
        live = e.isIntersecting; root.classList.toggle('live', live); if (live) root.classList.add('seen'); else humLevel(false);
        if (live && attract && state === 'idle' && ready) startLoop();
      }); }, { threshold: .15 }).observe(root.querySelector('.ucl-fit'));
    } else { live = true; root.classList.add('live', 'seen'); }

    /* ---------- tilt: the cabinet leans a little toward the pointer / with the phone, the glass glare slides ---------- */
    if (fxo.tilt && !reduce) {
      var tq = false, tx = 0, ty = 0;
      cab.classList.add('ucl-tilt');
      function tiltTo(nx, ny) { tx = clamp(nx, -1, 1); ty = clamp(ny, -1, 1); if (!tq) { tq = true; requestAnimationFrame(function () { tq = false;
        var on = state === 'idle' || state === 'done';
        cab.style.transform = on ? 'perspective(900px) rotateY(' + (tx * 7).toFixed(2) + 'deg) rotateX(' + (-ty * 5).toFixed(2) + 'deg)' : '';
        glass.style.setProperty('--gx', (on ? tx : 0).toFixed(3));
      }); } }
      addEventListener('pointermove', function (e) { if (!live || e.pointerType === 'touch') return; var r = cab.getBoundingClientRect(); tiltTo((e.clientX - (r.left + r.width / 2)) / (r.width * 1.2), (e.clientY - (r.top + r.height / 2)) / (r.height * 1.2)); }, { passive: true });
      addEventListener('deviceorientation', function (e) { if (!live || e.gamma == null) return; tiltTo(e.gamma / 25, ((e.beta || 45) - 45) / 25); }, { passive: true });
    }

    function loadPrizes() {
      var list = [], seq = Promise.resolve();
      (data.items || []).forEach(function (it) {
        seq = seq.then(function () { return cutout(it.src).then(function (r) {
          if (!r) return; var nm = split(it.title);
          list.push({ img: r.url, a: r.a, mask: r.mask, t: kind(r.a), brand: nm[0], name: nm[1], url: it.url, price: it.price });
        }); });
      });
      return seq.then(function () {
        var mx = -1, jp = null; list.forEach(function (p) { if (p.price > mx) { mx = p.price; jp = p; } }); if (jp) jp.j = 1;
        PR = layout(list);
      });
    }
    /* prize board (computers): the jackpot piece, what everything else pays, and every piece in the machine */
    function paintBoard() {
      var b = q('[data-board]'), hw = q('[data-how]'); if (hw) hw.innerHTML = howHTML(data); if (!b) return;
      var jp = PR.filter(function (p) { return p.j; })[0], cur = data.currency || '$',
          oJ = codes.jackpotOff || data.maxOff || 15, oW = codes.winOff || 10, oM = codes.missOff || 5;
      var h = '<div class="ucl-eye"><span>Prize board</span><span>This month</span></div>';
      if (jp) h += '<a class="ucl-jp" href="' + esc(jp.url) + '"><div class="ucl-jp-tag"><span>★ Jackpot</span><span>' + oJ + '% off</span></div>'
        + '<div class="ucl-jp-b"><img src="' + jp.img + '" alt=""><div><div class="ucl-jp-br">' + esc(jp.brand) + '</div><div class="ucl-jp-n">' + esc(jp.name) + '</div>'
        + '<div class="ucl-jp-p"><s>' + money(jp.price, cur) + '</s>' + money(Math.round(jp.price * (100 - oJ) / 100), cur) + '</div></div></div></a>';
      h += '<div class="ucl-pr"><span>Any other piece</span><b>' + oW + '%<em>off</em></b></div>'
        + '<div class="ucl-pr"><span>Miss all 3 pulls</span><b>' + oM + '%<em>off</em></b></div>'
        + '<div class="ucl-in"><div class="ucl-in-l"><span>In the machine</span><span>' + PR.length + ' pieces</span></div><div class="ucl-ths" style="--c:' + (PR.length <= 8 ? 4 : 5) + '">'
        + PR.map(function (p) { return '<a class="ucl-th' + (p.j ? ' jp' : '') + '" href="' + esc(p.url) + '" title="' + esc(p.brand + ' ' + p.name) + '"><img src="' + p.img + '" alt="' + esc(p.brand + ' ' + p.name) + '"></a>'; }).join('')
        + '</div></div>';
      b.innerHTML = h;
    }
    if (q('[data-how]')) q('[data-how]').innerHTML = howHTML(data);
    paintWallet(); scaleFit(); W = glass.clientWidth; H = glass.clientHeight; x = prevX = HOME(); paintTries(); paintTime(); render();
    msg.innerHTML = 'Loading<small>Stocking the machine</small>'; msg.classList.add('on'); msg.classList.remove('blink');
    loadPrizes().then(function () {
      var jp = PR.filter(function (p) { return p.j; })[0];
      if (jp) { TICK = 'URBAN.LEB ✦ THE CLAW ✦ JACKPOT: ' + jp.brand + ' ' + jp.name + ' — ' + (codes.jackpotOff || data.maxOff || 15) + '% OFF ✦ 3 PULLS A GAME ✦ '; setTick(TICK + TICK); }
      paintBoard(); buildPile(); ready = true; x = prevX = HOME(); render(); idleMsg(); paintWallet(); scaleFit();
      if (attract && live) startLoop();
    });
    addEventListener('resize', function () { scaleFit(); if (state === 'idle' && ready) { buildPile(); x = prevX = HOME(); render(); } });
    /* keep it fitted when the sheet or the content changes size (fonts landing, the header shrinking, the wallet growing) */
    if ('ResizeObserver' in window) { var rq = 0, ro = new ResizeObserver(function () { cancelAnimationFrame(rq); rq = requestAnimationFrame(scaleFit); }); ro.observe(root); ro.observe(fit); }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(scaleFit);
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-claw]:not([data-claw-on])'), function (el) { el.setAttribute('data-claw-on', '1'); Machine(el); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
